/*function setShy(_lang) {
    let shyElements = ['.styles-back>div', '.styles-back h1'];

    shyElements.forEach(function(item, i, shyElements) {
        $(`${item}`).attr('lang', _lang).addClass('hyphenate');
    });

    Hyphenator_Loader.init(
        {
            _lang: "automatically"
        },
        "/js/Hyphenator.js"
    );
}*/

//setShy('en');


// WEBPACK FOOTER //
// ./_src/js/modules/Shy.js